import { render, staticRenderFns } from "./formAddress.vue?vue&type=template&id=151f7420&"
import script from "./formAddress.vue?vue&type=script&lang=js&"
export * from "./formAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports